import React from "react";
import { Link, useNavigate, useParams } from "react-router-dom";
import { Typography, Button, Row, Col, Breadcrumb } from "antd";
import PatientMedicineTable from "../../../components/Tables/PatientMedicinesTable";
import { translate } from "../../../locale";

const { Title } = Typography;

const PatientMedicine = () => {
  const navigate = useNavigate();
  const { username } = useParams();

  return (
    <div className="flex flex-col items-start min-h-full w-screen max-w-7xl pb-16 m-10">
      <Row gutter={16} className="w-full">
        <Col className="gutter-row" span="20">
          <Breadcrumb>
            <Breadcrumb.Item>
              <Link to="/admin">Inicio</Link>
            </Breadcrumb.Item>
            <Breadcrumb.Item>
              <Link to={`/admin/buscar-paciente/${username}`}>
                {translate("Resumen individual")}
              </Link>
            </Breadcrumb.Item>
            <Breadcrumb.Item>Medicamentos del Paciente</Breadcrumb.Item>
          </Breadcrumb>
          <Breadcrumb>
            <Breadcrumb.Item>{username}</Breadcrumb.Item>
          </Breadcrumb>
        </Col>
        <Col span={24} className="my-4">
          <Title level={2} className="text-center">
            Medicamentos del Paciente
          </Title>
        </Col>
        <Col span={24}>
          <Button
            id="boton_id_para_franco"
            type="primary"
            className="px-10 bg-white text-black my-6"
            onClick={() => {
              navigate(
                `/admin/medicamentos/buscar/${encodeURIComponent(
                  "/admin/buscar-paciente/" + username
                )}/${username}`
              );
            }}
          >
            Nuevo medicamento
          </Button>
        </Col>
        <Col className="flex justify-center w-full flex-col">
          <PatientMedicineTable />
        </Col>
      </Row>
    </div>
  );
};

export default PatientMedicine;
